import { render } from "./SafcoDashboard.vue?vue&type=template&id=40bdae97"
import script from "./SafcoDashboard.vue?vue&type=script&lang=js"
export * from "./SafcoDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__